  // Sticky CTA — appears after scrolling past hero
  (function(){
    var bar = document.getElementById('stickyCta');
    if(!bar) return;
    var threshold = 600;
    var ticking = false;
    function update(){
      if(window.scrollY > threshold){
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  })();

  // Buy-box gallery carousel — main image swap + thumb arrows
  (function(){
    var main = document.getElementById('buyBoxMainImg');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.buybox__thumb'));
    if(!main || !thumbs.length) return;
    function setActive(idx){
      if(idx < 0) idx = thumbs.length - 1;
      if(idx >= thumbs.length) idx = 0;
      thumbs.forEach(function(t, i){
        t.classList.toggle('buybox__thumb--active', i === idx);
      });
      var active = thumbs[idx];
      if(active){
        main.src = active.getAttribute('data-large') || active.src;
      }
    }
    thumbs.forEach(function(t, i){
      t.addEventListener('click', function(){ setActive(i); });
    });
    function currentIdx(){
      return thumbs.findIndex(function(t){ return t.classList.contains('buybox__thumb--active'); });
    }
    var prev = document.getElementById('thumbPrev');
    var next = document.getElementById('thumbNext');
    if(prev) prev.addEventListener('click', function(){ setActive(currentIdx() - 1); });
    if(next) next.addEventListener('click', function(){ setActive(currentIdx() + 1); });
  })();

  // Tier selection — active state + CTA price sync
  (function(){
    var tiers = document.querySelectorAll('.tier-card');
    var ctaPrice = document.getElementById('checkoutCtaPrice');
    tiers.forEach(function(t){
      t.addEventListener('click', function(){
        tiers.forEach(function(x){ x.classList.remove('tier-card--active'); });
        t.classList.add('tier-card--active');
        if(ctaPrice && t.dataset.ctaTotal){
          ctaPrice.textContent = t.dataset.ctaTotal;
        }
      });
    });
  })();

  // Buy-box accordion uses native <details> — no JS needed
